import React from "react";

import { PeriodicMatchContainer } from "../../../containers";

const PeriodicMatch = (props) => {
  return <PeriodicMatchContainer {...props} />;
};

export default PeriodicMatch;
